<template>
  <div>
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="back">
      </div>
      <div class="header-card-text">
        <h3>Savings Challenge</h3>
        <p class="sub-text fnt-14">{{ plan.name }}</p>
      </div>
    </div>
    <div class="content">
      <div v-if="pageLoading" class="text-center mt-5">
        <vue-loaders-ball-pulse color="red" scale=".75"></vue-loaders-ball-pulse>
        <p class="loadingText">Please wait</p>
      </div>
      <div v-else>
        <div>
          <div class="balances">
            <div class="account_balance cabin-family">
              <p class="fnt-14">Saved Funds</p>
              <p class="bold">₦ {{ Number(balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </p>
            </div>
            <div class="account_balance2 cabin-family">
              <p class="fnt-14">Accrued Interest</p>
              <p class="bold">₦ {{ Number(interest).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </p>
            </div>
          </div>

          <p class="open-sans bold">Description</p>
          <p>{{ plan.description }}</p>

          <div class="mt-3">
            <p class="open-sans bold">History</p>
            <div class="trans-table">
              <div v-if="savings.length > 0">
                <!-- eslint-disable-next-line max-len -->
                <div class="trans-table-row" v-for="(saving, ind) in savings.slice().reverse()" :key="ind">
                  <div class="row2">
                    <p class="p1">Amount saved</p>
                    <p class="p2">₦{{ Number(saving.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                  </div>
                  <div class="row1">
                    <p class="p1">Date Created</p>
                    <p class="p2">{{ saving.createdAt | formatDate }}</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="text-center fnt-10 error open-sans">You do not have payment history
                  for this challenge</p>
              </div>
            </div>
          </div>
          <br>
          <form @submit="saveFund">
            <div class="form-group" v-if="id == 5 || id == 6 || id == 8">
              <label class="open-sans bold">Amount to Save</label>
              <!-- eslint-disable-next-line max-len -->
              <input type="number" v-model="amount" placeholder="Amount" class="form-control" required>
            </div>
            <div class="form-group" v-else>
              <label>Select amount to save</label>
              <select class="form-control" v-model="amount">
                <option v-for="(opt, index) in planOptions" :key="index" :value="opt">
                  ₦{{ (opt).toLocaleString() }}</option>
              </select>
            </div>
            <button class="btn primary-btn btn-block open-sans" :disabled="isDisabled">
              <span v-if="!loading">Save ₦{{ Number(amount).toLocaleString() }} </span>
              <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
              </vue-loaders-ball-spin-fade-loader></button>
          </form>
        </div>
      </div>
    </div>
    <success-component v-if="showSuccess" :message="successMsg" @close="closePrompt">
    </success-component>
    <error-component v-if="showError" :message="errorMsg" @close="closePrompt"></error-component>
    <!-- eslint-disable-next-line max-len -->
    <prompt-component v-if="showPrompt" :message="promptMsg" @yes="yes" @no="no" :yes="'Add to existing'"
      :no="'Create new'"></prompt-component>
  </div>
</template>

<script>
import ErrorComponent from '../components/Error.vue';
import SuccessComponent from '../components/Success.vue';
import PromptComponent from '../components/Prompt.vue';

export default {
  props: ['id'],
  components: {
    ErrorComponent,
    SuccessComponent,
    PromptComponent,
  },
  created() {
    this.getPlan();
  },
  computed: {
    isDisabled() {
      if (!this.amount || (this.walletBalance < this.amount || this.amount <= 0)) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      plan: {},
      showSuccess: false,
      showError: false,
      showPrompt: false,
      pageLoading: true,
      balance: 0,
      interest: 0,
      amount: 0,
      walletBalance: 0,
      savings: [],
      loading: false,
      transactions: [],
      errorMsg: '',
      successMsg: '',
      promptMsg: '',
      topUp: false,
      planOptions: [],
      plan1: [15000, 5250, 24750, 38250, 6750, 12750, 16500, 2250, 18750, 14250,
        8250, 25500, 9000, 30000, 11250, 15750, 6000, 17250, 3750, 20250, 16500,
        13500, 23250, 45000, 15750, 6750, 14250, 8250, 12750, 3750, 21750, 11250,
        14250, 19500, 6000, 15000, 3000, 16500, 13500, 12750, 15000, 21000, 4500,
        11250, 26250, 14250, 16500, 21000, 14250, 6750, 4500],
      plan2: [20000, 7000, 33000, 51000, 9000, 17000, 22000, 3000, 25000, 19000,
        11000, 34000, 12000, 40000, 15000, 21000, 8000, 23000, 5000, 27000, 22000,
        18000, 31000, 60000, 21000, 9000, 19000, 11000, 17000, 5000, 29000, 15000,
        19000, 26000, 8000, 20000, 4000, 22000, 18000, 17000, 20000, 28000, 6000,
        15000, 35000, 19000, 22000, 28000, 19000, 9000, 6000],
      plan3: [100000, 35000, 165000, 255000, 45000, 85000, 110000, 15000, 125000,
        95000, 55000, 170000, 60000, 200000, 75000, 105000, 40000, 115000, 25000,
        135000, 110000, 90000, 155000, 300000, 105000, 45000, 95000, 55000, 85000,
        25000, 145000, 75000, 95000, 130000, 40000, 100000, 20000, 110000, 90000,
        85000, 100000, 140000, 30000, 75000, 175000, 95000, 110000, 140000, 95000,
        45000, 30000],
      plan4: [200000, 70000, 330000, 510000, 90000, 170000, 220000, 30000, 250000,
        190000, 110000, 340000, 120000, 400000, 150000, 210000, 80000, 230000, 50000,
        270000, 220000, 180000, 310000, 600000, 210000, 90000, 190000, 110000, 170000,
        50000, 290000, 150000, 190000, 260000, 80000, 200000, 40000, 220000, 180000, 170000,
        200000, 280000, 60000, 150000, 350000, 190000, 220000, 280000, 190000, 90000, 60000],
    };
  },
  methods: {
    async getPlan() {
      this.pageLoading = true;
      const url = `${this.$baseUrl}/savings/challenge/${this.id}`;
      const res = await this.$http({ url, method: 'GET' });
      this.plan = res.data.plan;
      this.balance = res.data.balance;
      this.savings = res.data.savings;
      this.interest = res.data.interest;
      this.walletBalance = res.data.walletBalance;
      this.pageLoading = false;
      let planOptions = [];
      if (this.id === '1') {
        planOptions = this.plan1;
      }
      if (this.id === '2') {
        planOptions = this.plan2;
      }
      if (this.id === '3') {
        planOptions = this.plan3;
      }
      if (this.id === '4') {
        planOptions = this.plan4;
      }
      const planIds = [];
      this.savings.map((plan) => planIds.push(plan.amount));
      console.log('Plan IDs, ', planIds);
      // eslint-disable-next-line no-plusplus
      for (let ind = 0; ind < planIds.length; ind++) {
        const el = planIds[ind];
        // eslint-disable-next-line no-plusplus
        for (let ind1 = 0; ind1 < planOptions.length; ind1++) {
          const el1 = planOptions[ind1];
          if (el === el1) {
            planOptions.splice(ind1, 1);
            break;
          }
        }
      }
      console.log('Plan Options, ', planOptions);
      // this.planOptions = planOptions.filter((x) => planIds.indexOf(x) === -1);
      this.planOptions = planOptions;
    },
    yes() {
      this.topUp = true;
      this.showPrompt = false;
      this.lockFund();
    },
    no() {
      this.topUp = false;
      this.showPrompt = false;
      this.lockFund();
    },
    async saveFund(e) {
      e.preventDefault();
      this.loading = true;
      try {
        const data = {
          amount: this.amount,
          planId: this.id,
          topUp: this.topUp,
        };
        const url = `${this.$baseUrl}/savings/challenge/${this.id}`;
        await this.$http({ url, data, method: 'POST' });
        this.amount = '';
        this.successMsg = 'Funds saved Successfully';
        this.getPlan();
        this.showSuccess = true;
        this.loading = false;
      } catch (error) {
        this.errorMsg = error.response.data.message;
        this.showError = true;
        this.loading = false;
        setTimeout(() => {
          this.showError = false;
        }, 3000);
      }
    },
    back() {
      this.$router.go(-1);
    },
    closePrompt() {
      this.showError = false;
      this.showSuccess = false;
      this.showCoopPop = false;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #EE0E4C;
  font-weight: 400;
}

p {
  margin-bottom: .25rem;
}

.balances {
  display: flex;
  justify-content: space-between;
}

.account_balance {
  margin: 0 0 1rem 0;
  background-color: #EE0E4C;
  color: #FFF;
  padding: .5rem;
  text-align: center;
  font-size: 20px;
  line-height: 1;
  border-radius: 8px;
  width: 45%;
}

.account_balance2 {
  margin: 0 0 1rem 0;
  background-color: #FFF;
  border: 1px solid #EE0E4C;
  color: #EE0E4C;
  padding: .5rem;
  text-align: center;
  font-size: 20px;
  line-height: 1;
  border-radius: 8px;
  width: 45%;
}

.trans-table {
  padding: 1rem;
  border-radius: 8px;
  background-color: #FFF;

  &-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .75rem 0;
    border-bottom: 1px solid #E5E5E5;

    &:last-child {
      border-bottom: none;
    }
  }

  .p1 {
    font-size: 11px;
    line-height: 12px;
    color: #49566A;
    font-family: 'Cabin', sans-serif;
  }

  .p2 {
    font-family: 'Cabin', sans-serif;
    font-weight: 600;
    font-size: 14px;
  }
}

.transactions {
  margin-top: 1rem;
}

form {
  margin-bottom: 2rem;
}

.notification {
  text-align: center;
  font-family: 'Cabin', sans-serif;
  font-weight: 600;
  font-size: 16px;

  // margin-top: 2rem;
  p {
    margin-bottom: 1rem;
  }
}

.loadingText {
  font-size: 20px;
}

.success-label {
  background-color: rgba($color: #50A948, $alpha: 0.2);
  color: #50A948;
  padding: .25rem;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
}

.process-label {
  background-color: #FFDDE6;
  color: #EE0E4C;
  padding: .25rem;
  border-radius: 8px;
  font-weight: 400;
  font-size: 11px;
  text-align: center;
}

.empty-trans {
  margin-top: 2rem;
  text-align: center;
  color: #6b6b6b;
}
</style>
